(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeePhoneDialogController', EmployeePhoneDialogController);

    /* Added $locale
    EmployeePhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EmployeePhone', 'Employee', 'AdvertisingSource'];

    function EmployeePhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EmployeePhone, Employee, AdvertisingSource) {
    */
    EmployeePhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EmployeePhone', 'Employee', 'AdvertisingSource', 'PhoneType', '$locale'];

    function EmployeePhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EmployeePhone, Employee, AdvertisingSource, PhoneType, $locale) {
        var vm = this;

        vm.employeePhone = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        /*
        vm.employees = Employee.query();
        vm.advertisingsources = AdvertisingSource.query();
        */
        vm.employees = Employee.query({size: 9999, sort: 'fullname,asc', actual: false});
        vm.advertisingsources = AdvertisingSource.query({size: 9999, sort: 'name,asc', actual: false});
        vm.phonetypes = PhoneType.query({size: 9999, sort: 'name,asc', actual: false});
        vm.dateformat = $locale.DATETIME_FORMATS.short;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.employeePhone.id !== null) {
                EmployeePhone.update(vm.employeePhone, onSaveSuccess, onSaveError);
            } else {
                EmployeePhone.save(vm.employeePhone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:employeePhoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.bindingTime = false;
        vm.datePickerOpenStatus.unbindingTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
